export default __webpack_public_path__ + "static/media/check-green.b4c5b350.svg";